import { render, staticRenderFns } from "./personalReservationList.vue?vue&type=template&id=639f2284&scoped=true"
import script from "./personalReservationList.vue?vue&type=script&lang=js"
export * from "./personalReservationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639f2284",
  null
  
)

export default component.exports